/*
 * Angular 2 decorators and services
 */
import { pairwise, filter } from 'rxjs/operators';
import {
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { AppState } from './app.service';

import { Hotkey, HotkeysService } from 'angular2-hotkeys';

import { TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs';

import { ConfigService } from './shared/config/config.service';

import {
  RoutesRecognized,
  Router
} from '@angular/router';
import { TpaService } from './tpa/shared/tpa.service';
import { NGXLogger } from 'ngx-logger';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './app.component.scss'
  ],
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit {
  public name = 'Office Management';
  public keyPressed: string;
  public userName: string;
  public enviornment: string;
  public loginArea: string;
  public organization: string;
  public isLogged: boolean = true;
  public officeTab: boolean = false;
  public terminalTab: boolean = false;
  public configTab: boolean = false;
  public ENV: any;
  public vendorSettingTab = false;
  public systemDataTab = false;
  public historyTab: any = 'N';
  public massiveTabVisible: boolean;
  public massDeviceTabVisible: boolean;
  public configurationTab: boolean = false;
  public date: any;
  public visitedColor: string = 'white';
  public arpUsap: boolean = false;
  constructor(
    public appState: AppState,
    private translate: TranslateService,
    private router: Router,
    public config: ConfigService,
    private tpaService: TpaService,
    public logger: NGXLogger
  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    let browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

  }

  public ngOnInit() {
    console.log('AppComponent');
    // Subscribe to isLoggedIn event
    this.config.isLoggedIn$.subscribe(
      (value) => setTimeout(() => this.getUserDetails(), 0)
    );
    // user details from token
    this.getUserDetails();
    this.router.events.pipe(
      filter((event) => event instanceof RoutesRecognized),
      pairwise(),).subscribe((e: any[]) => {
        this.appState.setPrevRoute(e[0].url);
      });
    interval(1000).subscribe(() => this.getDate());
  }

  /**
   * Change language
   * @param lang language to which application to be display
   */
  public changeLanguage(lang) {
    this.translate.use(lang);
  }
  public onClickTerminaTab() {
    this.tpaService.setErrorMessage(null);
  }

  public onClickSignOut() {
    sessionStorage.clear();
    // redirect to CLP

    let logoutURI = `https://${this.ENV}.accounts.amadeus.com/`;
    let redirectUri: string = location.protocol +
      '//' +
      location.hostname +
      (location.port ? ':' + location.port : '') +
      '/#/login?state=' +
      logoutURI;

    redirectUri = encodeURIComponent(redirectUri);
    let env = this.config.getEnv();
    let clp = this.config.getConfig('clpLogout');
    // incase of production this should be www.
    if (env === 'prd') {
      env = 'www';
    }
    const clpURL = clp.url.replace(/{ENV}/, env.toLowerCase());
    window.location.href = clpURL + redirectUri;
  }

  /**
   * Open Privacy statement link
   */
  public goToLink(url: string) {
    window.open(url, "_blank");
    this.visitedColor = 'white';
  }

  /**
   * get the supported language
   * @return languages supported
   */
  public getLanguages() {
    return this.translate.getLangs();
  }

  /**
   * get the current language of application
   * @return current application language
   */
  public getCurrentLanguage() {
    return this.translate.currentLang;
  }

  public getDate() {
    let d = new Date();
    this.date = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds()).toUTCString();
  }

  /**
   * Get user detail from token
   */
  public getUserDetails() {
    const user = sessionStorage.getItem('user');
    if (user) {
      this.isLogged = true;
      const userObj = JSON.parse(user);
      if (userObj) {
        this.userName = userObj.userDetails.userId;
        this.enviornment = userObj.userDetails.phase;
        this.loginArea = userObj.userDetails.officeId;
        this.organization = userObj.userDetails.organization;
        this.officeTab = (userObj.security && userObj.security.officeTab);
        this.terminalTab = (userObj.security &&
          userObj.security.terminalAndPrinterTab);
        this.configurationTab = userObj.security.configurationTab;
        this.configTab = (userObj.security && (userObj.security.vendorSettingTab || userObj.security.systemDataTab || userObj.security.configurationTab));
        this.vendorSettingTab = (userObj.security && userObj.security.vendorSettingTab);
        this.systemDataTab = (userObj.security && userObj.security.systemDataTab);
        this.historyTab = (userObj.security && userObj.security.historyTab);
        this.massiveTabVisible = (userObj.security && userObj.security.massiveTabVisible);
        this.massDeviceTabVisible = (userObj.security && userObj.security.massDeviceTabVisible);
      }
    } else {
      this.logger.log('Not logged in');
      this.isLogged = false;
    }
  }
}